import { css } from '@emotion/css';
import React from 'react';

export const BalloonShape: React.FC<{ style?: React.CSSProperties }> = ({ children, style }) => {
  return (
    <div
      className={css`
        position: relative;
        min-width: 200px;
        max-width: 480px;
        min-height: 160px;
        background-image: url('data:image/svg+xml,%3Csvg width="144" height="132" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg"%3E%3Cpath d="M141.435 75.619c-.947-3.045-1.843-5.925-1.843-9.619s.896-6.574 1.843-9.619c.825-2.638 1.671-5.364 2.064-9.003 1.258-11.52.956-24.722-10.724-35.286C121.539 1.924 102.751 0 72.001 0S22.462 1.924 11.226 12.092C-.464 22.656-.756 35.858.503 47.378c.392 3.639 1.248 6.365 2.064 9.003.946 3.045 1.842 5.925 1.842 9.619s-.896 6.574-1.842 9.619C1.74 78.257.895 80.983.503 84.622c-1.259 11.52-.957 24.722 10.723 35.286C22.462 130.076 41.26 132 72 132c30.739 0 49.538-1.924 60.774-12.092 11.68-10.564 11.972-23.766 10.724-35.286-.393-3.639-1.239-6.365-2.064-9.003z" fill="%23fff"/%3E%3C/svg%3E');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        margin: 0 auto;
        padding: 24px;
      `}
      style={style}
    >
      {children}
    </div>
  );
};
